import React, { useState, useRef } from "react"
import ReactSelect, { components, ValueContainerProps } from "react-select"

const MultiSelect = (props) => {
    const [selectInput, setSelectInput] = useState("")
    const isAllSelected = useRef(false)
    const selectAllLabel = useRef("Select all")
    const allOption = { value: "*", label: selectAllLabel.current }

    const filterOptions = (options, input) => options?.filter(({ label }) => label.toLowerCase().includes(input.toLowerCase()))
    const comparator = (v1, v2) => (v1.value - v2.value)

    const filteredOptions = filterOptions(props.options, selectInput)
    const filteredSelectedOptions = filterOptions(props.value, selectInput)

    const Option = (props) => (
        <components.Option {...props}>
            {/* {console.log(!isAllSelected.current, filteredSelectedOptions?.length)} */}
            {props.value === "*" &&
                !isAllSelected.current &&
                filteredSelectedOptions?.length > 0 ? (
                <input
                    className="form-check-input dd"
                    key={props.value}
                    type="checkbox"
                    ref={(input) => {
                        if (input) input.indeterminate = true
                    }}
                />
            ) : (
                <input
                    key={props.value}
                    className="form-check-input ff"
                    type="checkbox"
                    checked={props.isSelected || isAllSelected.current}
                    onChange={() => { }}
                />
            )}
            <label style={{ marginLeft: "5px" }}>{props.label}</label>
        </components.Option>
    )

    const Input = (props) => (
        <>
            {selectInput.length === 0 ? (
                <components.Input autoFocus={props.selectProps.menuIsOpen} {...props}>
                    {props.children}
                </components.Input>
            ) : (
                <div style={{ border: "1px dotted gray" }}>
                    <components.Input autoFocus={props.selectProps.menuIsOpen} {...props}>
                        {props.children}
                    </components.Input>
                </div>
            )}
        </>
    )

    const customFilterOption = ({ value, label }, input) => (value !== "*" && label.toLowerCase().includes(input.toLowerCase())) ||
        (value === "*" && filteredOptions?.length > 0)

    const onInputChange = (inputValue, event) => {
        if (event.action === "input-change") setSelectInput(inputValue)
        else if (event.action === "menu-close" && selectInput !== "") setSelectInput("")
    }

    const onKeyDown = (e) => {
        if ((e.key === " " || e.key === "Enter") && !selectInput) e.preventDefault()
    }

    const handleChange = (selected) => {
        if (
            selected.length > 0 &&
            !isAllSelected.current &&
            (selected[selected.length - 1].value === allOption.value ||
                JSON.stringify(filteredOptions) ===
                JSON.stringify(selected.sort(comparator)))
        ) return props.onChange([
            ...(props.value ?? []),
            ...props.options.filter(
                ({ label }) => label.toLowerCase().includes(selectInput?.toLowerCase()) &&
                    (props.value ?? []).filter((opt) => opt.label === label)
                        .length === 0
            )
        ].sort(comparator)
        )
        else if (
            selected.length > 0 &&
            selected[selected.length - 1].value !== allOption.value &&
            JSON.stringify(selected.sort(comparator)) !==
            JSON.stringify(filteredOptions)
        ) return props.onChange(selected)
        else return props.onChange([
            ...props.value?.filter(
                ({ label }) => !label.toLowerCase().includes(selectInput?.toLowerCase())
            )
        ])
    }

    const customStyles = {
        multiValueLabel: (def) => ({
            ...def,
            backgroundColor: "lightgray"
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#000',
            fontSize: "14px"
        }),
        multiValueRemove: (def) => ({
            ...def,
            backgroundColor: "lightgray"
        }),
        valueContainer: (base) => ({
            ...base,
            maxHeight: "40px",
            overflow: "auto",
            padding: '2px 0px 2px 4px',
            fontSize: '14px'
        }),
        // indicatorSeparator: state => ({
        //      display: 'none'
        // }),
        // indicatorsContainer: (provided, state) => ({
        //     ...provided,
        //     height: '30px'
        // }),
        dropdownIndicator: (styles) => ({
            ...styles,
            padding: '6px'
        }),
        clearIndicator: (styles) => ({
            ...styles,
            padding: '6px'
        }),
        option: (styles, { isSelected, isFocused, isActive }) => ({
            ...styles,
            display: "flex",
            backgroundColor: (isActive || isSelected || isFocused) ? "#00adc32b !important" : "transparent",
            borderBottom: "1px solid #ccc",
            fontSize: "14px",
            color: isSelected ? null : null,
            cursor: "pointer",
            label: {
                opacity: "1",
                transform: "unset !important",
                fontSize: "12px !important",
                padding: "0px 10px",
                margin: "0px",
                fontWeight: "500 !important",
                backgroundColor: 'unset !important'
            }
        }),
        control: (styles, { isFocused }) => ({
            ...styles,
            cursor: "pointer",
            alignItems: "center",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            minHeight: "38px",
            outline: "0!important",
            transition: "all 100ms",
            backgroundColor: "hsl(0, 0%, 100%)",
            borderColor: "#00adc300",
            borderRadius: "4px",
            borderStyle: "solid",
            borderWidth: "1px",
            // boxShadow: "0 0 0 1px #00acd3",
            boxSizing: "border-box",
            border: "1px solid #b4b4b4",
            padding: "5px",
            "&:hover": {
                //  borderColor: "#00adc300",
                // border: "1px solid #b4b4b4"
            },
            "&:active": {
                // borderColor: "unset",
                // border: "unset"
            }

            // boxShadow: isFocused ? "0 0 0 2px #00acd3" : "none"
        }),
        menu: (def) => ({
            ...def,
            zIndex: 9999,
            minWidth: '400px',
            maxHeight: "420px",
            overflowY: "auto !important"
        })
    }

    const CustomValueContainer = ({ children, ...props }) => {
        let [values, input] = children
        input = input
        if (Array.isArray(values)) {
            // const plural = values.length === 1 ? "" : "s"
            values = `${values.length} selected`
        }

        return (
            <components.ValueContainer {...props}>
                {values}
                {input}
            </components.ValueContainer>
        )
    }


    if (props.isSelectAll && props.options.length !== 0) {
        isAllSelected.current =
            filteredSelectedOptions.length === filteredOptions.length
        selectAllLabel.current = "Select all"
        allOption.label = selectAllLabel.current

        return (
            <div className="testing" >
                <ReactSelect
                    {...props}
                    inputValue={selectInput}
                    onInputChange={onInputChange}
                    onKeyDown={onKeyDown}
                    options={[allOption, ...props.options]}
                    onChange={handleChange}
                    components={{
                        Option,
                        Input,
                        ...props.components,
                        ValueContainer: CustomValueContainer
                    }}
                    filterOption={customFilterOption}
                    menuPlacement={props.menuPlacement ?? "auto"}
                    styles={customStyles}
                    isMulti
                    closeMenuOnSelect={false}
                    tabSelectsValue={false}
                    backspaceRemovesValue={false}
                    hideSelectedOptions={false}
                    blurInputOnSelect={false}
                    placeholder='Select Companies'
                />
            </div>

        )
    }

    return (
        <div className="testing" >
            <ReactSelect
                {...props}
                inputValue={selectInput}
                onInputChange={onInputChange}
                filterOption={customFilterOption}
                components={{
                    Input,
                    ...props.components,
                    ValueContainer: CustomValueContainer
                }}
                menuPlacement={props.menuPlacement ?? "auto"}
                onKeyDown={onKeyDown}
                tabSelectsValue={false}
                hideSelectedOptions={true}
                backspaceRemovesValue={false}
                blurInputOnSelect={true}
                placeholder='Select Companies'
                styles={customStyles}
            />
        </div>

    )
}

export default MultiSelect
